<template>
  <div class="copyright">
    <div class="copy-right">
      <div class="copy-center w1200">
        <div>
          <img src="/static/images/bg_ft_logo.png" alt="">
        </div>
        <div>
          <p class="copt-title">World Taekwondo Headquarters</p>
          <!-- <p class="copy-text">Booyoung Taepyung Building 10th Floor, </p>
          <p class="copy-text">55, Sejong-daero (Taepyung-ro 2ga), Jung-gu, </p>
          <p class="copy-text">Seoul, Republic of Korea, 04513</p>
          <p class="copy-text">Tel : +82 2 566 2505</p>
          <p class="copy-text">Fax : +82 2 553 4728</p> -->
          <!-- <p class="copy-text">Contact information</p> -->
        </div>
        <div>
          <p class="copt-title">World Taekwondo Lausanne Office</p>
          <!-- <p class="copy-text">Avenue de Rhodanie 54 1007 Lausanne </p> -->
          <!-- <p class="copy-text">Switzerland </p> -->
          <!-- <p class="copy-text">Email: office@worldtaekwondo.org</p>
          <p class="copy-text">Tel : +41 21 601 50 13</p>
          <p class="copy-text">Fax : +41 21 601 59 83</p> -->
        </div>
        <div>
          <p class="copt-title">CONNECT WITH US</p>
          <p class="connect-icon">
            <span class="Facebook"></span>
            <span class="Instagram"></span>
            <span class="Twitter"></span>
            <span class="Youtube"></span>
          </p>
        </div>
      </div>
      <div class="copy-right-text">www.chinawtf.org Copyright  2007</div>
    </div>
  </div>
</template>

<script>

export default {
  name: '',

  data () {
    return {
      aboutInfo: {}
    }
  },
  methods: {

  },
  mounted () {

  },
  created () {
    // this.aboutInfo = JSON.parse(localStorage.getItem('aboutInfo'))
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
  .copyright{
    width: 100%;
    background: #e7e7e7;
  }
  .copy-right{
    width: 100%;
    background: #222;
  }
  .copy-center{
    color: #eaeaea;
    padding: 10px 0px;
    display: flex;
    justify-content: space-around;
  }
  .copt-title{
    font-size: 15px;
    line-height: 24px;
    font-weight: 600;
  }
  .copy-text{
    font-size: 12px;
    line-height: 21px;
  }
  .connect-icon{
    overflow: hidden;
  }
  .connect-icon span{
    width: 23px;
    height: 23px;
    background-position: 0px 0px;
    background-repeat: no-repeat;
    background-size: 100% 100%;
    float: left;
    margin-right: 10px;
    cursor: pointer;
  }
  .Facebook{
    background-image: url(/static/images/web-Facebook.png)
  }
  .Facebook:hover{
    background-image: url(/static/images/web-Facebook1.png)
  }
  .Instagram{
    background-image: url(/static/images/instagram.png)
  }
  .Instagram:hover{
    background-image: url(/static/images/instagram1.png)
  }
  .Twitter{
     background-image: url(/static/images/twitter.png)
  }
  .Twitter:hover{
    background-image: url(/static/images/twitter1.png)
  }
  .Youtube{
     background-image: url(/static/images/you-tube.png)
  }
  .Youtube:hover{
    background-image: url(/static/images/you-tube1.png)
  }
  /* .copy-center span{
    font-size: 14px;
    color:#fff;
    padding: 0px 15px;
    border-right: 1px solid #fff;
    line-height: 1;
  } */
  .copy-center span:last-child{
    border-right: none;
  }

  .copy-right-text{
    background-color: #0d0d0d;
    color: #ccc;
    font-size: 12px;
    text-align: center;
    padding: 10px 0px;
  }
</style>



// WEBPACK FOOTER //
// src/components/common/CopyRight/CopyRight.vue